/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_PreviewInputs */

const en_us2_profile_editors_preview = /** @type {(inputs: Profile_Editors_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your week looks like this`)
};

const pt_br2_profile_editors_preview = /** @type {(inputs: Profile_Editors_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua semana fica assim`)
};

const es_419_profile_editors_preview = /** @type {(inputs: Profile_Editors_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Así queda tu semana`)
};

const pt_pt2_profile_editors_preview = /** @type {(inputs: Profile_Editors_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tua semana fica assim`)
};

const fr_fr2_profile_editors_preview = /** @type {(inputs: Profile_Editors_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voici ta semaine`)
};

const de_de2_profile_editors_preview = /** @type {(inputs: Profile_Editors_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So sieht deine Woche aus`)
};

const it_it2_profile_editors_preview = /** @type {(inputs: Profile_Editors_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua settimana sarà così`)
};

/**
* | output |
* | --- |
* | "Your week looks like this" |
*
* @param {Profile_Editors_PreviewInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_preview = /** @type {((inputs?: Profile_Editors_PreviewInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_PreviewInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_preview(inputs)
	if (locale === "es-419") return es_419_profile_editors_preview(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_preview(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_preview(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_preview(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_preview(inputs)
	return en_us2_profile_editors_preview(inputs)
});
export { profile_editors_preview as "profile-editors.preview" }